import { useFormContext } from 'react-hook-form';
import { LwFormSelect } from 'redesign';
import { Props, VatFormContext } from './vat.types';
import { getRequiredMessage } from './shared';

export const VatSelect = (props: Props) => {
  const { control } = useFormContext<VatFormContext>();
  const formName = 'vat';
  const label = 'BTW-tarief';
  const requiredMessage = getRequiredMessage(label);

  return (
    <LwFormSelect
      name={formName}
      control={control}
      label={label}
      disabled={props.disabled}
      options={props.options}
      rules={props.required ? { required: requiredMessage } : undefined}
    />
  );
};
